export const DASHBOARD_TODO_LIST_FEATURE_HINT_IDS = {
    TITLE: 'dashboardTodoList.title',
    COMPLETION_ICON: 'dashboardTodoList.completionIcon',
    NEW_LABEL: 'dashboardTodoList.newLabel',
} as const;

export type DashboardTodoListFeatureHintId =
    (typeof DASHBOARD_TODO_LIST_FEATURE_HINT_IDS)[keyof typeof DASHBOARD_TODO_LIST_FEATURE_HINT_IDS];
